import { useState, useEffect } from 'react';
import { Container, Search, Content, ListUsers } from './styled';
import { Item } from './components';
import { IoIosSearch } from 'react-icons/io';
import { getUsersSystem } from '../../../../service/serviceChat/usersService';


export function InvitationUser(props) {

    const { customer } = props;

    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState('');



    useEffect(() => {
        async function loadUsers() {
            const res = await getUsersSystem()
            var aux = []
            res.forEach((user) => {
                if (user.tipo === 'G') return
                aux.push(user);
            })
            setUsers(aux)
        }
        loadUsers();
    }, [])

    function onFilter(obj) {
        return obj?.nomecompleto.toLowerCase().includes(search.toLowerCase());
    }

    return (
        <Container>
            <Search>
                <IoIosSearch style={{ fontSize: '1.5rem' }} />
                <input type='text' value={search} onChange={(e) => setSearch(e.target.value)} />
            </Search>
            <Content>
                <ListUsers>
                    {users.filter(onFilter).map((user) => (
                        <Item key={user.id} user={user} customer={customer} />
                    ))}
                </ListUsers>
            </Content>
        </Container>
    );
}           